import React from 'react';

import PropTypes from 'prop-types';

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { useDecedentForm } from '../../../hooks';
import Form from './Form';

const TITLE = 'Add a new decedent';

const NewDialog = ({ isOpen, onClose, onSuccess }) => {
  const { errorMessage, form, handleOpenChange, handleSubmit, isSubmitting } =
    useDecedentForm({
      onClose,
      onSuccess,
    });

  return (
    <Dialog onOpenChange={handleOpenChange} open={isOpen}>
      <DialogContent className="space-y-4">
        <DialogHeader>
          <DialogTitle>{TITLE}</DialogTitle>
        </DialogHeader>

        <Form
          errorMessage={errorMessage}
          form={form}
          isSubmitting={isSubmitting}
          onSubmit={handleSubmit}
        />
      </DialogContent>
    </Dialog>
  );
};

NewDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default NewDialog;
